module.exports = __webpack_public_path__ + "img/toRight.38f5ecfb.png";